import { useEffect, useCallback } from "react"
import { useParams, useSearchParams } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"
import {
    ROLE_FRANCHISE_MANAGER,
    ROLE_STORE_MANAGER,
} from 'shared/constant/lookup/role'
import useRoleCookie from 'shared/model/useRoleCookie'

const useGetFranchiseTicketTransactionHistoryList = () => {
    const [roleCookie] = useRoleCookie()
    const [fetchResult, fetchRequest, isLoading] = useFetch()
    const [, setAlert] = useAlertModalAtom()
    
    const [searchParams] = useSearchParams()
    const page = searchParams.get("page")
    const {idx} = useParams()
    const storeName = searchParams.get("storeName")
    const type = searchParams.get("classification")
    const ticketTypeIdx = searchParams.get("voucherType")
    const sortBy = searchParams.get("sortBy")
    const sortDirection = searchParams.get("sortDirection")


    const refetch = useCallback(() => {
        if (roleCookie === ROLE_FRANCHISE_MANAGER) {
            let url = `/admin/store_ticket/manager_detail?page=${page || 1}`
            if (idx) url += `&managerIdx=${idx}`
            if (storeName) url += `&managerIdx=${storeName}`
            if (ticketTypeIdx) url += `&ticketTypeIdx=${ticketTypeIdx}`
            if (type) url += `&type=${type}`
            if (sortBy) url += `&sortBy=${sortBy}`
            if (sortDirection) url += `&sortDirection=${sortDirection}`

            fetchRequest("GET", url)
        } else if (roleCookie === ROLE_STORE_MANAGER) {
            let url = `/admin/store_ticket/transfer_record?page=${page || 1}`
            if (ticketTypeIdx) url += `&ticketTypeIdx=${ticketTypeIdx}`
            if (type) url += `&type=${type}`
            if (sortBy) url += `&sortBy=${sortBy}`
            if (sortDirection) url += `&sortDirection=${sortDirection}`

            fetchRequest("GET", url)
        }
    }, [page, idx, storeName, ticketTypeIdx, type, sortBy, sortDirection])

    useEffect(() => {
        refetch()
    }, [refetch])

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 400:
                if (fetchResult?.data?.error_code === "page") setAlert("페이지 번호 입력 양식을 확인해 주세요.")
                break
        }
    }, [fetchResult])

    return [fetchResult, isLoading, refetch]
}

export default useGetFranchiseTicketTransactionHistoryList